import cookie from "react-cookies";
import Action from "../action/Action.ts";

import { AccommodataionJson } from "./AccommodataionJson";
import { API_PATH_ACCOMMODATION, COOKIE_NAME_ACCOMMODATION_LIST } from "./AccommodationConstant.ts";

import { GetItemFromList } from "./GetItemFromList.ts";
import ResponseData from "../action/ResponseData.ts";
import Accommodation from "./Accommodation.ts";

export const AccommodationAction = {
    getList(token: string, callback: Function, errorHandler: Function) {
        const cookie_saved_accommodataion_data: string | undefined = cookie.load(cookie.load(COOKIE_NAME_ACCOMMODATION_LIST));
        if (cookie_saved_accommodataion_data) {
            const response_data = new ResponseData();
            response_data.data = JSON.parse(cookie_saved_accommodataion_data);
            callback(response_data);
        } else {
            const url = API_PATH_ACCOMMODATION;
            Action.fetchAuthorizedJson(url, token, "GET", new Headers(), null, callback, errorHandler);
        }
    },
    getById(token: string, id: number, callback: Function, errorHandler: Function) {
        const cookie_saved_accommodataion_data: Array<AccommodataionJson> | undefined = cookie.load(COOKIE_NAME_ACCOMMODATION_LIST);

        if (cookie_saved_accommodataion_data) {
            // Ensure the cookie contains a JSON string before parsing
            let accommodation_list: Array<AccommodataionJson> = cookie_saved_accommodataion_data;

            if (typeof cookie_saved_accommodataion_data === "string") {
                accommodation_list = JSON.parse(cookie_saved_accommodataion_data);
            }

            const found_accommodation: Accommodation | null = GetItemFromList.getFromJsonList(accommodation_list, id);
            if (found_accommodation) {
                const response_data = new ResponseData();
                response_data.data = found_accommodation;
                callback(response_data);
            } else {
                errorHandler({ error: 1 });
            }
        } else {
            Action.fetchAuthorizedJson(
                API_PATH_ACCOMMODATION,
                token,
                "GET",
                new Headers(),
                null,
                function (e: ResponseData) {
                    //const str: string = JSON.stringify(e.data.accommodations);
                    //SaveOnCookie.saveList(str);
                    const accommodation_list: Array<AccommodataionJson> = e.data.accommodations;
                    const found_accommodation: Accommodation | null = GetItemFromList.getFromJsonList(accommodation_list, id);
                    if (found_accommodation) {
                        const response_data = new ResponseData();
                        response_data.data = found_accommodation;
                        callback(response_data);
                    } else {
                        errorHandler({ error: 1 });
                    }
                },
                function () {
                    errorHandler({ error: 1 });
                }
            );
        }
        return null;
    },
};
